import type { Novidade } from './tipos';

/** Fase 2 (W28): cobrança pelo Asaas pronta para a operação (automática, baixa com tarifa, estorno e cancelamento). */
export const novidadeAsaas: Novidade = {
  id: '2026-10-05-asaas',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: 'contas',
  permissao: 'contas.ver',
  textos: {
    pt: {
      titulo: 'Cobrança pelo Asaas',
      resumo: 'A fatura já sai com Pix, boleto ou cartão do Asaas, e o pagamento dá baixa sozinho, com a taxa do Asaas lançada como tarifa.',
      passos: [
        'Em Contas > Cobranças, ligue "Gerar cobrança ao emitir a fatura", escolha a forma e a conta das baixas do Asaas.',
        'Na ficha da fatura, "Gerar cobrança" oferece Pix, boleto, cartão de crédito ou deixar o cliente escolher.',
        'O pagamento confirmado no Asaas baixa a fatura com juros, multa e a tarifa; estorno e cancelamento valem nos dois lados.',
      ],
    },
    en: {
      titulo: 'Charging through Asaas',
      resumo: 'Invoices go out with an Asaas Pix, bank slip or card charge, and payments are recorded on their own, with the Asaas fee as a bank fee.',
      passos: [
        'In Receivables > Collections, turn on "Create the charge when the invoice is issued" and pick the method and the account for Asaas payments.',
        'On the invoice, "Create charge" offers Pix, bank slip, credit card or letting the customer choose.',
        'A payment confirmed at Asaas records the invoice payment with interest, fine and the fee; refunds and cancellations apply on both sides.',
      ],
    },
    es: {
      titulo: 'Cobro por Asaas',
      resumo: 'La factura sale con Pix, boleto o tarjeta de Asaas, y el pago se registra solo, con la tasa de Asaas como comisión bancaria.',
      passos: [
        'En Cuentas > Cobros, activa "Generar el cobro al emitir la factura" y elige la forma y la cuenta de los pagos de Asaas.',
        'En la factura, "Generar cobro" ofrece Pix, boleto, tarjeta de crédito o dejar que el cliente elija.',
        'El pago confirmado en Asaas registra la baja con intereses, multa y la tasa; reembolsos y cancelaciones valen en los dos lados.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-asaas/configuracao.webp', '/novidades/2026-10-05-asaas/cobranca.webp', '/novidades/2026-10-05-asaas/estorno.webp'],
  treinamento: { curso: 'novidades' },
  rota: '/financeiro/contas/cobrancas',
};
